import { useAuth } from '../../../../hooks/auth'
import { HeaderMenuDefault } from '../MenuDefault'
import { HeaderMenuAuthenticated } from '../MenuAuthenticated'

export const MenuSelector = () => {
  const auth = useAuth()
  if (auth.isAuthenticated) return <HeaderMenuAuthenticated />
  return <HeaderMenuDefault />
}
